export const contactData = [
  {
    id: "19",
    locationName: "Bangalore (rural) District Table Tennis Association",
    contactPerson: "Nandan R ",
    contactMobile: "98452 40220",
    latitude: "13.049437",
    longitude: "77.551031",
  },
  {
    id: "20",
    locationName: "Bangalore (urban) District Table Tennis Association",
    contactPerson: "Manoharan G",
    contactMobile: "94488 08663 ",
    latitude: "12.98542",
    longitude: "77.61776",
  },
  {
    id: "21",
    locationName: "Belagavi District Table Tennis Association",
    contactPerson: "Sangam Bailoor ",
    contactMobile: "9844053526",
    latitude: "15.837698",
    longitude: "74.500917",
  },
  {
    id: "22",
    locationName: "Bellary District Table Tennis Association ",
    contactPerson: "Gunalan ",
    contactMobile: "94481 27447",
    latitude: "15.263816",
    longitude: "76.333332",
  },
  {
    id: "23",
    locationName: "Chikmaglur District Table Tennis Association ",
    contactPerson: "Manoj Kumar ",
    contactMobile: "98440 28001 ",
    latitude: "13.131802",
    longitude: "75.640777",
  },
  {
    id: "24",
    locationName: "Dakshina Kannada District Table Tennis Association",
    contactPerson: "M.A. Khan ",
    contactMobile: "9900771375 ",
    latitude: "12.946534",
    longitude: "74.82024",
  },
  {
    id: "25",
    locationName: "Davanagere District Table Tennis Association ",
    contactPerson: "Basavaraj Dammalli",
    contactMobile: "9986917072",
    latitude: "14.45689",
    longitude: "75.924606",
  },
  {
    id: "26",
    locationName: "Dharwad District Table Tennis Association ",
    contactPerson: "Upadhya TG ",
    contactMobile: "94483 32421",
    latitude: "14.45689",
    longitude: "75.924606",
  },
  {
    id: "27",
    locationName: "Gulbarga District Table Tennis Association ",
    contactPerson: "Shivakumar",
    contactMobile: "94482 52048 ",
    latitude: "17.312042",
    longitude: "76.815262",
  },
  {
    id: "28",
    locationName: "Hassan District Table Tennis Association    ",
    contactPerson: "Ramesh HS ",
    contactMobile: "94480 65465 ",
    latitude: "13.002234",
    longitude: "76.091721",
  },
  {
    id: "29",
    locationName: "Kodagu District Table Tennis Association ",
    contactPerson: "Thimmaiah MP ",
    contactMobile: "94498 22020",
    latitude: "12.400367",
    longitude: "75.780753",
  },
  {
    id: "30",
    locationName: "Kolar District Table Tennis Association   ",
    contactPerson: "Sridhar M",
    contactMobile: "94489 93266",
    latitude: "13.13271",
    longitude: "78.133776",
  },
  {
    id: "31",
    locationName: "Mandya District Table Tennis Association ",
    contactPerson: "President: Dr. Ravindra Ph.D",
    contactMobile: "mailhovera@yahoo.com",
    latitude: "12.522157",
    longitude: "76.900919",
  },
  {
    id: "32",
    locationName: "Mysore District Table Tennis Association",
    contactPerson: "Raghavendra MN ",
    contactMobile: "94487 73413 ",
    latitude: "12.295947",
    longitude: "76.623825",
  },
  {
    id: "33",
    locationName: "Raichur District Table Tennis Association",
    contactPerson: "Veeranna",
    contactMobile: "9481546514",
    latitude: "16.190546",
    longitude: "77.341044",
  },
  {
    id: "34",
    locationName: "Shimoga District Table Tennis Association ",
    contactPerson: "Ramesh Shastry HD ",
    contactMobile: "98455 62626 ",
    latitude: "13.949771",
    longitude: "75.56158",
  },
  {
    id: "35",
    locationName: "Tumkur District Table Tennis Association ",
    contactPerson: "Amarnath GR ",
    contactMobile: "97413 99009",
    latitude: "13.343212",
    longitude: "77.101501",
  },
  {
    id: "36",
    locationName: "Udupi District Table Tennis Association",
    contactPerson: "Jayachandra Rao IK ",
    contactMobile: "ikjayachandrarao@gmail.com",
    latitude: "13.348061",
    longitude: "74.76149",
  },
  {
    id: "37",
    locationName: "Uttarakannada District Table Tennis Association ",
    contactPerson: "Sitaram Bhagwat ",
    contactMobile: "seetaramrb@gmail.com ",
    latitude: "14.427548",
    longitude: "74.419093",
  },
];
